import {Main} from '../../components/main/main.tsx';

import {Page} from '../../components/page/page.tsx';
import {Card} from '../../components/card/card.tsx';
import {useAppSelector} from '../../store/store.ts';
import {__} from '../../support/lang/translations.ts';
import {FlexRow} from '../../components/utility/flex_row.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {Spacer} from '../../components/utility/spacer.tsx';
import {Hero} from '../../components/hero/hero.tsx';
import {SocialButton, SocialMediaLoginType} from '../../components/button/social_button.tsx';
import FacebookLogin, {FacebookLoginClient, SuccessResponse} from '@greatsumini/react-facebook-login';
import {useEffect} from 'react';
import {useAppDispatch} from '../../store/store.ts';
import {facebookLogin} from '../../store/slices/exchange_token_slice.ts';
import {isFulfilled} from '@reduxjs/toolkit';
import {loginRedirectRoute} from '../../support/login_redirect_route.ts';
import {redirect, useNavigate} from 'react-router-dom';

export function SelectLoginMethod() {
    const appConfig = useAppSelector((state) => state.appConfig.appconfig);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const facebookId = appConfig?.show_facebook_login && appConfig?.facebook_id;
    const googleId = appConfig?.show_google_login && appConfig?.google_id;
    useEffect(() => {
        if (facebookId) {
            FacebookLoginClient.init({appId: facebookId, version: 'v16.0'});
        }
    }, [facebookId]);

    const onLoginSuccess = async (response: SuccessResponse) => {
        const result = await dispatch(facebookLogin(response.accessToken));
        if (isFulfilled(result) && result.payload.facebookLogin) {
            navigate(loginRedirectRoute(result.payload.facebookLogin));
        }
        redirect('/');
    };

    return (
        <Main>
            <Hero
                url={appConfig?.loginscreen}
                urls={[appConfig?.sliderphoto1, appConfig?.sliderphoto2, appConfig?.sliderphoto3]}
            />
            <Page>
                <Card style={{width: '100%', maxWidth: 400, marginTop: '-4rem', zIndex: 998}}>
                    <FlexRow alignment={Alignment.Center}>
                        <h2 style={{textAlign: 'center'}}>
                            {__('login.titles.main')} {appConfig?.appname}
                        </h2>
                    </FlexRow>
                    <Spacer />
                    <FlexRow alignment={Alignment.Center}>
                        <p style={{textAlign: 'center'}}>{__('login.copy.index')}</p>
                    </FlexRow>
                    {googleId && (
                        <>
                            <Spacer />
                            <SocialButton platform={SocialMediaLoginType.Google} to="google">
                                {__('login.buttons.google')}
                            </SocialButton>
                        </>
                    )}
                    {facebookId && (
                        <>
                            <Spacer />
                            <FacebookLogin appId={facebookId} onSuccess={onLoginSuccess} style={{display: 'none'}} />
                            <SocialButton
                                platform={SocialMediaLoginType.Facebook}
                                onClick={() => {
                                    FacebookLoginClient.login(
                                        (response) => {
                                            if (response.authResponse) {
                                                void onLoginSuccess(response.authResponse);
                                            }
                                        },
                                        {
                                            scope: 'public_profile, email',
                                        },
                                    );
                                }}
                            >
                                {__('login.buttons.facebook')}
                            </SocialButton>
                        </>
                    )}
                    <Spacer />
                    <SocialButton platform={SocialMediaLoginType.Email} to="email">
                        {__('login.buttons.email')}
                    </SocialButton>
                </Card>
            </Page>
        </Main>
    );
}
